import React from "react";
import { useTranslation } from "react-i18next";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import s from "./SearchFieldButtonBar.module.scss";

const SearchFieldButtonBar = ({
  loading,
  collapse,
  handleCollapse,
  resetBtn,
  handleReset,
  searchBtn,
  handleSearch,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.searchFieldBtnBar}>
      {
        <div style={{ display: collapse != undefined ? "block" : "none" }}>
          {collapse ? (
            <button
              className={[s.expandBtn, s.functionalBtn].join(" ")}
              onClick={() => handleCollapse(false)}
            >
              <span>{t("component.searchField.title.expand")}</span>
              <ExpandMoreIcon sx={{ fontSize: 18 }} />
            </button>
          ) : (
            <button
              className={[s.expandBtn, s.functionalBtn].join(" ")}
              onClick={() => handleCollapse(true)}
            >
              <span>{t("component.searchField.title.collapse")}</span>
              <ExpandLessIcon sx={{ fontSize: 18 }} />
            </button>
          )}
        </div>
      }

      <div></div>

      <div className={s.resetSearchButtonContainer}>
        {resetBtn && (
          <button
            className={[s.resetBtn, s.functionalBtn].join(" ")}
            onClick={handleReset}
            disabled={loading}
          >
            <span>{t("component.searchField.title.reset")}</span>
          </button>
        )}
        {searchBtn && (
          <button
            className={[s.searchBtn, s.functionalBtn].join(" ")}
            onClick={() => handleSearch("search")}
          >
            <span>{t("component.searchField.title.search")}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default React.memo(SearchFieldButtonBar);
